<template>
  <div>
    <template v-if="cdpProfileFilter && cdpProfileFilter.length">
      <el-card class="customer-profile" v-for="(data, index) in cdpProfileFilter" :key="`first-${index}`">
        <div class="customer-profile-title">{{ data.title }}</div>
        <div class="customer-profile-box" v-for="(item, index) in data.content" :key="`sec-${index}`">
          <div class="customer-profile-subtitle">{{ item.title }}</div>
          <div class="customer-profile-wrap" v-for="(cont, index) in item.content" :key="`third-${index}`">
            <div class="customer-profile-item">
              <div class="customer-profile-item-title">{{ cont.title }}</div>
              <div class="customer-profile-item-content">{{ cont.content }}</div>
            </div>
          </div>
        </div>
      </el-card>
    </template>
    <div v-else class="no-data">
      暂无数据
    </div>
  </div>
</template>

<script>
export default {
  props: {
    cdpProfile: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    cdpProfileFilter() {
      if(this.cdpProfile && this.cdpProfile.length) {
        return this.cdpProfile.filter(data => {
          data.content = data.content.filter(item => {
            item.content  = item.content.filter(cont => {
              return cont.content != ''
            })
            return item.content.length
          })
          return data.content.length
        })
      }
      return []
    }
  },
  data() {
    return {
    }
  },
  methods: {
  }
}
</script>
<style scoped>
.customer-profile + .customer-profile {
  margin-top: 10px;
}
.customer-profile-title {
  font-size: 16px;
  font-weight: 600;
  margin: 10px 0;
}

.customer-profile-box {
  padding-left: 20px;
  display: inline-block;
  width: 45%;
  vertical-align: top;
}

.customer-profile-subtitle {
  font-size: 14px;
  font-weight: 600;
  color: #409EFF;
  margin: 8px 0;
}

.customer-profile-wrap {
  padding-left: 20px;
}

.customer-profile-item {
  display: flex;
  margin: 4px 0;
}

.customer-profile-item-title {
  width: 200px;
}

.customer-profile-item-content {
  flex: 1
}

.no-data {
  text-align: center;
  min-height: 200px;
  line-height: 200px;
  font-size: 14px;
  color: #909399;
}
</style>